import React, { useEffect, useRef, useState } from 'react';
import FlowingMeshCanvas from '../FlowingMeshCanvasAlt';

const perksData = [
    {
        id: 1,
        title: "Flexible Work Schedule",
        description: "Enjoy the flexibility to work your way and bring out your best.",
    },
    {
        id: 2,
        title: "International Collaborations",
        description: "Work with talented people worldwide, learn from each other, grow together.",
    },
    {
        id: 3,
        title: "Top of the Line Resources",
        description: "Bring your ideas to life with simple, modern technology.",
    },
    {
        id: 4,
        title: "Support and Benefits",
        description: "We’re here for you, supporting you through every challenge.",
    },
    {
        id: 5,
        title: "Learning & Development",
        description: "Keep learning and growing with practical workshops, valuable certifications, and guidance from experienced mentors.",
    },
];

const PerksAndBenefits = () => {
    const containerRef = useRef(null);
    const [progressHeight, setProgressHeight] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const elementHeight = rect.height;

            let scrolled = (windowHeight / 2 - rect.top) / (elementHeight - windowHeight / 2);
            scrolled = Math.max(0, Math.min(1, scrolled));

            const totalItems = perksData.length;
            const index = Math.min(
                totalItems - 1,
                Math.floor(scrolled * totalItems)
            );

            setProgressHeight(scrolled * 100);
            setActiveIndex(index);
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <section className="w-full bg-white relative" ref={containerRef}>
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] py-10 lg:py-24">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">

                    {/* Left Side: Sticky Content */}
                    <div className="lg:w-1/2 relative">
                        {/* Mobile: sticky removed or handled simply, Desktop: sticky top-32 */}
                        <div className="lg:sticky lg:top-32">
                            <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[25px]">
                                Perks and Benefits
                            </h2>

                            <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-[22px] lg:leading-[24px] max-w-[476px]">
                                We know people do their best work when they feel supported, so we’re here to help you every step of the way.       </p>

                            {/* Canvas Background: Reduced height on mobile */}
                            <div className="w-full h-[150px] lg:h-[300px] opacity-100 pointer-events-none -z-10 mt-5 lg:mt-0">
                                <FlowingMeshCanvas />
                            </div>
                        </div>
                    </div>

                    {/* Desktop Progress Bar (Visible only on Desktop) */}
                    <div className="hidden lg:block w-[4px] bg-gray-200 relative rounded-full self-stretch">
                        <div
                            className="absolute top-0 left-0 w-full bg-[#ED6800] rounded-full transition-all duration-300 ease-out"
                            style={{ height: `${progressHeight}%` }}
                        ></div>
                        <div
                            className="absolute left-0 h-[20px] w-[20px] transition-all duration-300 ease-out"
                            style={{
                                top: `${progressHeight}%`,
                                transform: 'translateY(-50%) translateX(2px)'
                            }}
                        >
                            <img src="/assets/nav/logo.svg" alt="" />
                        </div>
                    </div>

                    {/* Right Side: Perk Cards */}
                    <div className="lg:w-1/2 flex flex-col gap-[15px] lg:gap-[14px]">
                        {perksData.map((perk, index) => (
                            <div
                                key={perk.id}
                                className={`transition-all duration-500 p-[20px] lg:p-[35px] border-l-4 lg:border-none rounded-r-lg lg:rounded-none
                                    ${index === activeIndex
                                        ? 'bg-[#F9F9F9] border-[#ED6800] lg:bg-[#F2F4F8] shadow-sm'
                                        : 'bg-white border-transparent'
                                    }
                                `}
                            >
                                <h3 className={`text-[16px] lg:text-[20px] font-[600] font-sora mb-[10px] lg:mb-[26px] transition-colors duration-300 text-[#01386A]`}>
                                    {perk.title}
                                </h3>
                                <p className="text-[#49577A] font-[500] font-graphik w-full text-[14px] lg:text-[16px] leading-[22px] lg:leading-[24px]">
                                    {perk.description}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PerksAndBenefits;